'use client'

import { MOTION_DURATION } from '@brew/ui/motion'
import { Check, Copy } from 'lucide-react'
import { AnimatePresence, motion } from 'motion/react'

/** Icon-swap recipe: the two icons cross-fade in one slot through a 2px
 * blur and a slight scale, 250ms, overlapping rather than queued. */
const ICON_HIDDEN = { opacity: 0, scale: 0.8, filter: 'blur(2px)' }
const ICON_SHOWN = { opacity: 1, scale: 1, filter: 'blur(0px)' }

export function AnimatedCopyIcon({
  copied,
  className,
}: {
  copied: boolean
  className: string
}) {
  return (
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.span
        key={copied ? 'check' : 'copy'}
        initial={ICON_HIDDEN}
        animate={ICON_SHOWN}
        exit={ICON_HIDDEN}
        transition={{ duration: MOTION_DURATION.fast, ease: 'easeInOut' }}
        className="flex items-center justify-center"
      >
        {copied ? (
          <Check className={`${className} text-emerald-500`} />
        ) : (
          <Copy className={`${className} text-muted-foreground`} />
        )}
      </motion.span>
    </AnimatePresence>
  )
}
